export default __webpack_public_path__ + "static/media/stack-overflow.2ff7d6f6.svg";